<template>
  <div class="form-container">
    <div class="alert alert-info p-3">
      <div
        class="text-muted text-center mb-3"
      >
        {{ $t(TITLES[exposureType]) }}
      </div>
      <div
        class="d-flex justify-content-center align-items-center"
      >
        <div class="d-none d-md-block">
          <v-button
            size="lg"
            :icon="ICONS[exposureType]"
            style-type="info"
            :text="BUTTON_TEXT[exposureType]"
            @click="showMediaContainer = true"
          />
        </div>
        <div class="d-block d-md-none">
          <v-button
            size="sm"
            :icon="ICONS[exposureType]"
            style-type="info"
            :text="BUTTON_TEXT[exposureType]"
            id="watch-exposure"
            @click="showMediaContainer = true"
          />
        </div>
      </div>
    </div>
    <transition name="fade">
      <div
        class="media-container w-100 d-flex justify-content-center align-items-center"
        v-if="showMediaContainer"
      >
        <div
          class="alert alert-danger m-0"
          v-if="showError"
        >
          {{ $t('sentence.not_allowed_to_fast_forward') }}
          <v-button
            text="phrase.start_again"
            style-type="secondary"
            size="sm"
            @click="showError = false"
          />
        </div>
        <div v-else-if="exposureType === 'video'" class="w-100">
          <v-video
            :youtube-id="researchItem.youtube_id"
            :auto-play="true"
            :full-size="true"
            @playing="emitProgress"
            @finished="closeMedia"
          />
        </div>
        <div v-else-if="exposureType === 'audio'" class="w-100">
          <div v-if="!showError">
            <v-audio
              :source="researchItem.audio_file"
              :autoplay="true"
              @playing="emitProgress"
              @finished="closeMedia"
            />
          </div>
        </div>
        <div
          class="bg-white"
          v-else-if="exposureType === 'image'"
        >
          <v-image
            :source="researchItem.image_file"
            :duration="5"
            @finished="closeMedia"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Audio from '@/common/components/Audio.vue';
import Button from '@/common/components/Button.vue';
import Video from '@/common/components/Video.vue';
import Image from '@/common/components/Image.vue';
import { GenericItemMixin } from '@/reviewer/mixins';

const TITLES = {
  video: 'text.watch_commercial_and_proceed',
  audio: 'text.listen_to_commercial_and_proceed',
  image: 'text.watch_image_and_proceed',
};


const BUTTON_TEXT = {
  video: 'phrase.watch_commercial',
  audio: 'phrase.listen_to_commercial',
  image: 'phrase.view_image',
};

const ICONS = {
  video: 'video',
  audio: 'headphones',
  image: 'image',
};

export default {
  name: 'ItemMedia',
  components: {
    'v-button': Button,
    'v-video': Video,
    'v-audio': Audio,
    'v-image': Image,
  },
  mixins: [
    GenericItemMixin,
  ],
  computed: {
    exposureType() {
      if (this.researchItem.audio_file) {
        return 'audio';
      }
      if (this.researchItem.image_file) {
        return 'image';
      }
      if (this.researchItem.youtube_id) {
        return 'video';
      }
      return '';
    },
  },
  data() {
    return {
      TITLES,
      BUTTON_TEXT,
      ICONS,
      showError: false,
      showMediaContainer: false,
      exposed: false,
    };
  },
  methods: {
    emitProgress(params) {
      this.$emit('playing', params);

      if (params.fastForwarded) {
        this.showError = true;
      }
    },
    closeMedia() {
      this.showMediaContainer = false;
      this.exposed = true;
      this.researchItem.answer.value = 100;
      this.$emit('value-changed');
    },
  },
};
</script>

<style scoped>
.media-container {
  z-index: 1050;
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
</style>
